(() => {
  'use strict';

  const instances = new WeakMap();

  const rootsIn = (scope) => {
    const roots = [];
    if (scope?.matches?.('[data-ld-pdp-engine]')) roots.push(scope);
    if (scope?.querySelectorAll) roots.push(...scope.querySelectorAll('[data-ld-pdp-engine]'));
    return roots;
  };

  const mount = (root) => {
    if (instances.has(root)) return;

    const groups = Array.from(root.querySelectorAll('[data-ld-engine-swatch-group]'));
    const buttons = Array.from(root.querySelectorAll('[data-ld-engine-swatch]'));
    if (!groups.length || !buttons.length) return;

    const controller = new AbortController();
    const { signal } = controller;
    const selects = Array.from(root.querySelectorAll('[data-ld-engine-option]'));

    const sync = () => {
      groups.forEach((group) => {
        const optionIndex = Number(group.dataset.optionIndex);
        const selectedValue = selects[optionIndex]?.value || '';
        const current = group.querySelector('[data-ld-engine-swatch-current]');
        if (current) current.textContent = selectedValue;

        group.querySelectorAll('[data-ld-engine-swatch]').forEach((button) => {
          const selected = button.dataset.optionValue === selectedValue;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const optionIndex = Number(button.dataset.optionIndex);
        const select = selects[optionIndex];
        if (!select || !button.dataset.optionValue) return;
        select.value = button.dataset.optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      }, { signal });
    });

    selects.forEach((select) => select.addEventListener('change', sync, { signal }));

    root.classList.add('has-color-swatches');
    sync();

    instances.set(root, {
      destroy() {
        controller.abort();
        root.classList.remove('has-color-swatches');
      }
    });
  };

  const init = (scope = document) => rootsIn(scope).forEach(mount);
  const destroy = (scope) => {
    rootsIn(scope).forEach((root) => {
      instances.get(root)?.destroy?.();
      instances.delete(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  window.LDPDPSwatches = { init, destroy };
})();
